import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";
import ContactForm from "shared/components/dashboardCommon/contactForm";

const ClientContact = () => {
  return (
    <div className={classNames(styles.mainEnclosure, "flex justify-center")}>
      <div className={classNames(styles.leftSide, "grid")}>
        <h1>Need Help? Contact Us!</h1>
        <p>
          We're here to help! If you're experiencing any technical issues or
          have a question about our product, please reach out to our support
          team using the email below. We'll get back to you as soon as possible.
        </p>
        <a
          href="tel:9727849044"
          className={classNames(styles.phoneEnclosure, "flex")}
        >
          <span className={classNames(styles.phoneIcon)}>
            <Icons.DummyPhone width={48} height={48} />
          </span>
          <h1 className={classNames(styles.leftSideFonts)}>972-784-9044</h1>
        </a>

        <a
          href="mailto:sales@tracyscustomhomes.com"
          className={classNames(styles.emailEnclosure, "flex")}
        >
          <span className={classNames(styles.phoneIcon)}>
            <Icons.DummyMessage width={48} height={48} />
          </span>
          <h1 className={classNames(styles.leftSideFonts)}>
            sales@tracyscustomhomes.com
          </h1>
        </a>
      </div>
      <div className={classNames(styles.divider)}></div>
      <div className={classNames(styles.rightSide)}>
        <ContactForm />
      </div>
    </div>
  );
};

export default ClientContact;
